exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1BRDAkaUTyfeIQc03wzIIu{display:block}", ""]);

// exports
exports.locals = {
	"groupPicture": "_1BRDAkaUTyfeIQc03wzIIu"
};